import React, { useEffect, useState } from "react";
import api, { formatApiError, asArray } from "../../lib/api";
import { Plus, Trash2, Edit3, X } from "lucide-react";
import { toast } from "sonner";

const inputCls = "w-full bg-transparent border-b border-black/15 focus:border-[#0060A7] outline-none py-2";
const textareaCls = "w-full bg-white border border-black/15 focus:border-[#0060A7] outline-none p-3 text-sm";

const blank = () => ({ title_ar: "", title_en: "", description_ar: "", description_en: "", icon: "Sparkles", order: 0, published: true });

export default function AdminServices() {
    const [items, setItems] = useState([]);
    const [editing, setEditing] = useState(null);

    const load = async () => {
        try { setItems(asArray((await api.get("/admin/services")).data, "services")); } catch (e) { toast.error(formatApiError(e)); }
    };
    useEffect(() => { load(); }, []);

    const save = async () => {
        try {
            const payload = { ...editing };
            payload.order = Number(payload.order) || 0;
            if (payload.id) await api.patch(`/admin/services/${payload.id}`, payload);
            else await api.post("/admin/services", payload);
            toast.success("Saved"); setEditing(null); load();
        } catch (e) { toast.error(formatApiError(e)); }
    };
    const remove = async (id) => {
        if (!window.confirm("Delete?")) return;
        try { await api.delete(`/admin/services/${id}`); load(); } catch (e) { toast.error(formatApiError(e)); }
    };

    if (editing) {
        const e = editing;
        return (
            <div data-testid="admin-service-form">
                <button onClick={() => setEditing(null)} className="text-sm text-[#6B7280] mb-6 inline-flex items-center gap-2"><X size={14} /> Cancel</button>
                <h2 className="heading text-3xl tracking-tight mb-8">{e.id ? "Edit Service" : "New Service"}</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white p-8">
                    <div><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Title (AR)</label><input className={inputCls} value={e.title_ar} onChange={(ev) => setEditing({ ...e, title_ar: ev.target.value })} /></div>
                    <div><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Title (EN)</label><input className={inputCls} value={e.title_en} onChange={(ev) => setEditing({ ...e, title_en: ev.target.value })} /></div>
                    <div><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Icon (Lucide name)</label><input className={inputCls} value={e.icon} onChange={(ev) => setEditing({ ...e, icon: ev.target.value })} /></div>
                    <div><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Order</label><input type="number" className={inputCls} value={e.order} onChange={(ev) => setEditing({ ...e, order: ev.target.value })} /></div>
                    <div className="md:col-span-2"><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Description (AR)</label><textarea rows={3} className={textareaCls} value={e.description_ar} onChange={(ev) => setEditing({ ...e, description_ar: ev.target.value })} /></div>
                    <div className="md:col-span-2"><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Description (EN)</label><textarea rows={3} className={textareaCls} value={e.description_en} onChange={(ev) => setEditing({ ...e, description_en: ev.target.value })} /></div>
                    <label className="inline-flex items-center gap-2 text-sm md:col-span-2"><input type="checkbox" checked={e.published} onChange={(ev) => setEditing({ ...e, published: ev.target.checked })} /> Published</label>
                </div>
                <div className="mt-6 flex gap-3">
                    <button onClick={save} className="bg-[#002951] hover:bg-[#0060A7] text-white px-8 py-3 text-sm uppercase tracking-[0.2em]">Save</button>
                </div>
            </div>
        );
    }

    return (
        <div data-testid="admin-services-page">
            <div className="flex items-center justify-between mb-6">
                <h1 className="heading text-3xl tracking-tight">Services</h1>
                <button onClick={() => setEditing(blank())} className="bg-[#002951] hover:bg-[#0060A7] text-white px-5 py-2.5 text-sm inline-flex items-center gap-2"><Plus size={14} /> New</button>
            </div>
            <div className="bg-white">
                <table className="w-full text-sm">
                    <thead className="bg-[#EFF0F1] text-left text-xs uppercase tracking-[0.2em] text-[#6B7280]"><tr><th className="p-4">Title</th><th className="p-4">Icon</th><th className="p-4">Order</th><th className="p-4"></th></tr></thead>
                    <tbody>
                        {items.map((s) => (
                            <tr key={s.id} className="border-t border-black/5">
                                <td className="p-4"><div className="heading">{s.title_en}</div><div className="text-xs text-[#6B7280]">{s.title_ar}</div></td>
                                <td className="p-4 text-[#6B7280]">{s.icon}</td>
                                <td className="p-4 text-[#6B7280]">{s.order}</td>
                                <td className="p-4 text-right">
                                    <button onClick={() => setEditing(s)} className="mr-3 text-[#0060A7]"><Edit3 size={16} /></button>
                                    <button onClick={() => remove(s.id)} className="text-red-500"><Trash2 size={16} /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
